import { render, staticRenderFns } from "./Payouts.vue?vue&type=template&id=2493c4f8&scoped=true&"
import script from "./Payouts.vue?vue&type=script&lang=js&"
export * from "./Payouts.vue?vue&type=script&lang=js&"
import style0 from "./Payouts.vue?vue&type=style&index=0&id=2493c4f8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2493c4f8",
  null
  
)

export default component.exports